import { useState } from 'react';
import { AccountModel, DonVi, DonViCoSo, HanThanhToan, KhachHang, QuyenChungTu } from '@/types/schemas';
import type { PhieuThuFormInitialData } from '../types';

export interface FormFieldState {
  khachHang: KhachHang | null;
  account: AccountModel | null;
  quyenChungTu: QuyenChungTu | null;
  hanThanhToan: HanThanhToan | null;
  donViCoSo: DonViCoSo | DonVi | null;
  soChungTu: string;
}

export interface FormFieldActions {
  setKhachHang: (khachHang: KhachHang) => void;
  setAccount: (account: AccountModel) => void;
  setQuyenChungTu: (quyenChungTu: QuyenChungTu) => void;
  setHanThanhToan: (hanThanhToan: HanThanhToan) => void;
  setDonViCoSo: (donViCoSo: DonViCoSo | DonVi) => void;
  setSoChungTu: (soChungTu: string) => void;

  resetState: () => void;
  updateState: (updates: Partial<FormFieldState>) => void;
}

export interface UseFormFieldStateReturn {
  state: FormFieldState;
  actions: FormFieldActions;
}

const initialState: FormFieldState = {
  khachHang: null,
  account: null,
  quyenChungTu: null,
  hanThanhToan: null,
  donViCoSo: null,
  soChungTu: ''
};

function transformInitialData(initialData?: PhieuThuFormInitialData): Partial<FormFieldState> {
  if (!initialData) return {};

  return {
    khachHang: initialData.ma_kh_data || null,
    account: initialData.tk_data || null,
    quyenChungTu: initialData.ma_nk_data || null,
    hanThanhToan: initialData.ma_tt_data || null,
    donViCoSo: initialData.unit_id_data || null,
    soChungTu: initialData.so_ct || ''
  };
}

export function useFormFieldState(initialData?: PhieuThuFormInitialData): UseFormFieldStateReturn {
  const [state, setState] = useState<FormFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: FormFieldActions = {
    setKhachHang: (khachHang: KhachHang) => {
      setState(prev => ({
        ...prev,
        khachHang
      }));
    },

    setAccount: (account: AccountModel) => {
      setState(prev => ({
        ...prev,
        account
      }));
    },

    setQuyenChungTu: (quyenChungTu: QuyenChungTu) => {
      setState(prev => ({
        ...prev,
        quyenChungTu
      }));
    },

    setHanThanhToan: (hanThanhToan: HanThanhToan) => {
      setState(prev => ({
        ...prev,
        hanThanhToan
      }));
    },

    setDonViCoSo: (donViCoSo: DonViCoSo | DonVi) => {
      setState(prev => ({
        ...prev,
        donViCoSo
      }));
    },

    setSoChungTu: (soChungTu: string) => {
      setState(prev => ({
        ...prev,
        soChungTu
      }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<FormFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
